import { render, staticRenderFns } from "./BdoMerchantB.vue?vue&type=template&id=19bd7a5a&scoped=true"
import script from "./BdoMerchantB.vue?vue&type=script&lang=js"
export * from "./BdoMerchantB.vue?vue&type=script&lang=js"
import style0 from "./BdoMerchantB.vue?vue&type=style&index=0&id=19bd7a5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bd7a5a",
  null
  
)

export default component.exports